import React from "react";
import "./Donors.css";
import {getDonors, hidePage, showPage} from "../extras/Actions";
import rama from "../../img/rama.png";

export default class Donors extends React.Component{

    componentDidMount() {
        hidePage()
        setTimeout(()=>{
            getDonors()
        },1000)
        setTimeout(showPage,3000)
    }
    render() {
        return (
            <div className="donors">
            </div>
        );
    }
}